require("./bootstrap");
require("./twitter");

// AlpineJS
import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

// Misc
window.Sortable = require("./sortable.js");
require("./onboarding.js");
require("./calendar.js");
require("./sms-modal.js");
require("./plans-modal.js");

// Toast
import "./toast.js";

$("body").on("click", ".send-text", function (e) {
    var id = $(this).data("id");
    $(".uauth").val(uauthToken);
    $(".circle-id").val(id);
});
$(".toggle-password").on("click", function (e) {
    $(e.currentTarget).hasClass("show")
        ? $("#inputPassword").attr("type", "text")
        : $("#inputPassword").attr("type", "password");
    $(e.currentTarget).hasClass("show")
        ? $(".toggle-password").removeClass("show")
        : $(".toggle-password").addClass("show");
});

window.Vapor = require("laravel-vapor");

// Copy to Clipboard
window.copyToClipboard = function (el, text) {
    const elem = document.createElement("textarea");
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);
    toast.alert("Link Copied!");
};

window.limit = function (element, maxLength) {
    if (element.value.length > maxLength - 1) {
        element.value = element.value.substr(0, maxLength - 1);
    }
};
